module.exports = __webpack_public_path__ + "img/shopee.65f72934.svg";